import '../assets/styles/home/home.css';
import {Hero} from "../components/home/hero";
import {Features} from "../components/home/features";
import {Preview} from "../components/home/preview";
import {Footer} from "../components/home/footer";
import {ToolsGallery} from "../components/home/toolsGallery";
import {useState} from "react";


interface IHome {
    globalTextColor: string;
    isLight: boolean;
}
export const Home: React.FC<IHome> = ({globalTextColor, isLight}) => {
    const [selectedEffect, setSelectedEffect] = useState('');

    const setCurSelectedEffect = (effect: string) => {
        setSelectedEffect(effect);
    }

    return (
        <div className={`text-[${globalTextColor}]`}>
            {/*Hero Section*/}
            <Hero isLight={isLight}/>
            {/*工具展览*/}
            <ToolsGallery isLight={isLight} />

            {/*功能区域*/}
            <Features isLight={isLight} setCurSelectedEffect={setCurSelectedEffect} />
            {/*实时预览区域*/}
            <Preview isLight={isLight} selectedEffect={selectedEffect} />

            {/*页脚*/}
            <Footer />
        </div>
    );
}
